import { render, staticRenderFns } from "./Diable10KMMPDialog.vue?vue&type=template&id=3658be5a&"
import script from "./Diable10KMMPDialog.vue?vue&type=script&lang=js&"
export * from "./Diable10KMMPDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports